import { Button } from '@chakra-ui/button';
import Icon from '@chakra-ui/icon';
import { Input } from '@chakra-ui/input';
import { Text } from '@chakra-ui/layout';
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from '@chakra-ui/modal';
import { useToast } from '@chakra-ui/toast';
import firebase from 'firebase';
import React, { useRef, useState } from 'react';
import { UserMinus } from 'react-feather';

interface DeleteUserAlertProps {
  currentUser: firebase.User;
}

export const DeleteUserAlert: React.FC<DeleteUserAlertProps> = ({
  currentUser,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [userPw, setUserPw] = useState('');
  const [userPwError, setUserPwError] = useState('');
  const deleteCustomerCancelRef = useRef(null);
  const toast = useToast();

  const deleteCustomer = () => {
    if (currentUser.email) {
      const credential = firebase.auth.EmailAuthProvider.credential(
        currentUser.email,
        userPw
      );
      currentUser
        .reauthenticateWithCredential(credential)
        .then(({ user }) => {
          user &&
            user.delete().then(() => {
              toast({
                title: 'Benutzer erfolgreich gelöscht.',
                status: 'success',
              });
              setIsOpen(false);
            });
        })
        .catch(async (e: firebase.auth.AuthError) => {
          await firebase
            .firestore()
            .collection('errors')
            .add({ id: 'deleteUser', error: JSON.stringify(e) });
          if (e.code === 'auth/wrong-password') {
            setUserPwError('Falsches Passwort. Bitte versuche es erneut.');
          }
        });
    }
  };

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        alignSelf="flex-start"
        variant="outline"
        colorScheme="red"
        leftIcon={<Icon as={UserMinus} />}
      >
        Benutzer löschen
      </Button>
      <AlertDialog
        isCentered={true}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        leastDestructiveRef={deleteCustomerCancelRef}
      >
        <AlertDialogOverlay>
          <AlertDialogContent c>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Benutzer löschen
            </AlertDialogHeader>

            <AlertDialogBody>
              <Text>
                Bist du dir sicher, dass du dich löschen möchtest?
                <br />
                Alle Daten gehen verloren.
              </Text>
              <Text my={3} fontWeight="bold">
                Bitte gib dein Passwort zum Bestätigen ein.
              </Text>
              <Input
                type="password"
                onChange={(e) => setUserPw(e.target.value)}
              />
              {userPwError && (
                <Text mt={2} color="red">
                  {userPwError}
                </Text>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={deleteCustomerCancelRef}
                onClick={() => setIsOpen(false)}
              >
                Abbrechen
              </Button>
              <Button colorScheme="red" onClick={deleteCustomer} ml={3}>
                Löschen
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};
